import { graphql } from '~/gql';

export const ConversationFieldsFragment = graphql(`
  fragment ConversationFields on Conversation {
    id
    matterId
    expertId
    createdAt
    attorneyLastReadAt
    expertLastReadAt
    unreadCount
  }
`);

export const ConversationDocument = graphql(`
  query Conversation($matterId: BigInt!, $expertId: BigInt!) {
    conversation(matterId: $matterId, expertId: $expertId) {
      ...ConversationFields
    }
  }
`);

export const MatterConversationsDocument = graphql(`
  query MatterConversations($matterId: BigInt!) {
    matterConversations(matterId: $matterId) {
      ...ConversationFields
    }
  }
`);

export const MessagesDocument = graphql(`
  query Messages($conversationId: BigInt!, $limit: Int, $before: BigInt) {
    messages(conversationId: $conversationId, limit: $limit, before: $before) {
      id
      conversationId
      senderId
      content
      createdAt
      sender {
        id
        email
      }
    }
  }
`);
